var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 20 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.91154 2.91169c1.86409-1.86432 4.39234-2.91169 7.02856-2.91169 2.6362 0 5.1645 1.04737 7.0286 2.91169s2.9113 4.39289 2.9113 7.02944c0 2.63657-1.0472 5.16507-2.9113 7.02947l-7.0286 7.0294-7.02856-7.0294c-.92307-.9231-1.65529-2.019-2.154852-3.2251-.499565-1.2061-.756688-2.4989-.756688-3.80437 0-1.30551.257123-2.59823.756688-3.80435.499562-1.20612 1.231782-2.30201 2.154852-3.22509zm7.02856 9.86961c.7532 0 1.4755-.2992 2.0081-.8319.5325-.5326.8317-1.255.8317-2.00827s-.2992-1.47568-.8317-2.00831c-.5326-.53264-1.2549-.83187-2.0081-.83187-.75316 0-1.47548.29923-2.00805.83187-.53258.53263-.83177 1.25504-.83177 2.00831s.29919 1.47567.83177 2.00827c.53257.5327 1.25489.8319 2.00805.8319z",
    fill: "#0b0c0d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.316899433c779332ab5f287a0a9db5fa.svg";
export { ForwardRef as ReactComponent };